<template>
  <el-form-item :label="item.title" :required="item.required&&item.required[operatorType]">
    <el-input :type="item.type" v-model="item.value" :disabled="disabled"
              :οnkeyup="item.value=item.value.replace(/[^\w]/g,'')"
              :placeholder="disabled?'':`请输入${item.title}`"
              v-if="type==='english-input'"/>
    <el-input :type="item.type" v-model="item.value" :disabled="disabled"
              :class="item.param==='remark'||item.param==='yarnType'?'lang-input':'normal'"
              :placeholder="disabled?'':`请输入${item.title}`"
              v-if="type==='input'"
              :maxlength="item.param==='remark'?item.maxlength:null"/>
    <el-input-number v-model="item.value" :disabled="disabled" v-if="type==='input-number'"
                     :step="item.style.step" :step-strictly="Boolean(item.style.step)"
                     :precision="item.style.precision"
                     :placeholder="`请输入${item.title}`"
                     :controls="false"
                     :min="0"/>
    <el-select v-model="item.value" :placeholder="disabled?'':`请选择${item.title}`"
               :disabled="disabled" @change="change"
               v-if="type==='select'">
      <el-option v-for="item in item.selectList"
                 :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-switch v-if="type==='switch'"
               v-model="item.value" :disabled="disabled"
               :class="[item.style&&item.style.inactive?'':'el-switch-font']"
               :active-text="item.style&&item.style.active?item.style.active:'是'"
               :inactive-text="item.style&&item.style.inactive?item.style.inactive:'否'"
               active-color="#5faee3" inactive-color="#d2d2d2"/>
    <slot :data="item" v-if="type==='slot'"/>
  </el-form-item>
</template>

<script>
  /**
   * @description 封装el-form-item组件
   * @author: 菩萨蛮
   * @date 2020/2/14 11:51 下午
   * @version V1.1.6
   *
   * 公司的业务千篇一律，复杂的代码好几百行
   *
   * 注：该方法会从自组件中直接修改父组件的值
   * v1.1.0 新增选择栏功能
   * v1.1.1 优化switch字段及参数
   * v1.1.2 去掉多余判断
   * v1.1.3 修复错误的selectList读取
   * v1.1.4 支持文件上传
   * v1.1.5 优化配置字段
   * v1.1.6 移除不合理的文件上传模块
   */

  export default {
    name: 'QxFormItem',
    props: {
      item: { type: Object },
      disabled: { type: Boolean },
      defaultValue: { type: String },
      operatorType: { type: String, default: 'new' }
    },
    data() {
      return {
        type: 'input'
      };
    },
    created() {
      if (this.item.type === 'input' || this.item.type === 'textarea') {
        this.type = 'input';
      } else if (this.item.type === 'select') {
        this.type = 'select';
      } else if (this.item.type === 'number') {
        this.type = 'input-number';
      } else if (this.item.type === 'english-input') {
        this.type = 'english-input';
      } else if (this.item.type === 'boolean') {
        this.type = 'switch';
      } else {
        this.type = 'slot';
      }
    },
    methods: {
      change(data) {
        this.$emit('change', data);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-input-group {
    vertical-align: middle;

    .el-button {
      margin: -1px -20px;
      font-size: 25px;
      line-height: 25px;
    }
  }
</style>
